<script>
import vSelect from 'vue-select';
import './css/vue-select.css';
import OpenIndicator from './OpenIndicator.vue';
import Deselect from './Deselect.vue';

vSelect.props.components.default = () => ({ OpenIndicator, Deselect });

export default vSelect;
</script>
